import PropTypes from 'prop-types'
import ReactTooltip from 'react-tooltip'
import useLexicon from '../../hooks/useLexicon'

const UserAvatar = ({
  size,
  borderRadius,
  photoUrl,
  isMentor,
  clickHandler,
  displayTooltip = true,
  userName,
}) => {
  const lexicon = useLexicon()

  const showOverlay = (e) => {
    e.currentTarget.classList.add('avatar-hovered')
  }

  const hideOverlay = (e) => {
    e.currentTarget.classList.remove('avatar-hovered')
  }

  const tooltipId = Math.floor(Math.random() * 1000000) + 1

  const style = {
    width: `${size || 0}px`,
    height: `${size || 0}px`,
    borderRadius: `${borderRadius || 0}px`,
    cursor: `${clickHandler ? 'pointer' : 'inherit'}`
  }

  return (
    <div
      className='avatar'>
      <div
        className={`user-photo-wrapper${clickHandler ? ' linked' : ''}`}
        style={style}
        onClick={clickHandler || undefined}
        onMouseOver={showOverlay}
        onMouseOut={hideOverlay}
        data-tip={userName || `${lexicon.mentor}` }
        data-for={`${tooltipId}`}>

        <img
          className='user-photo'
          alt={userName}
          src={photoUrl}
          style={style}
        />

        {isMentor &&
          <div
            className='mentor'
            style={{borderWidth: `0 0 ${size/3}px ${size/3}px`}}>
          </div>
        }
      </div>

      {(isMentor && displayTooltip) &&
        <ReactTooltip id={`${tooltipId}`} effect='solid' />
      }
    </div>
  )
}

UserAvatar.propTypes = {
  size: PropTypes.number,
  borderRadius: PropTypes.number,
  photoUrl: PropTypes.string,
  userName: PropTypes.string,
  clickHandler: PropTypes.func,
  isMentor: PropTypes.bool,
  displayTooltip: PropTypes.bool
}

export default UserAvatar
